// ColorBadge.jsx
import React from 'react';

const colorMap = {
  Current_Event: 'bg-green-500',
  Past_Event: 'bg-red-500',
  Comming_Event: 'bg-blue-600',
};

const ColorBadge = ({ label, status }) => {
  return (

    <div className="flex items-center gap-2">
      <span className={`w-3 h-3 rounded-full ${colorMap[status]}`}></span>
      <span className="text-sm font-medium capitalize">{label}</span>
    </div>

  );
};

export default ColorBadge;
